import React from 'react';
import SubscriptionFeature from '../features/subscription/Subscription';

const SubscriptionPage: React.FC = () => {
    return <SubscriptionFeature />;
};

export default SubscriptionPage;
